import type { AppState } from '@capacitor/app'
import mitt from 'mitt'

type Events = {
  appScroll: HTMLElement
  windowResize: undefined
  docContentClicked: undefined
  headerScrollUpdate: undefined
  showActionMenu: undefined
  overlayMenuOpened: undefined
  overlayMenuClosed: undefined
  closeOverlayMenu: undefined
  logoutOfflineFailure: undefined
  openSortPopup: undefined
  toggleNightMode: undefined
  docContentSelectionStarted: undefined
  showBookControlBar: undefined
  closeInAppBrowser16218: undefined
  stripeFinishedLoading16218: undefined
  appVisibilityChange: AppState
}

export const emitter = mitt<Events>()
